module.exports = __webpack_public_path__ + "img/9788952216175.50763523.jpg";